import { Button, Form, Typography } from "antd";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import checkImg from "../../assets/v2/check.png";
import style from "./ChangePassword.module.css";
import { useEffect, useState } from "react";

const { Title, Text, Paragraph } = Typography;

export default function Requested() {
  let location = useLocation();
  const [email, setEmail] = useState();
  const navigate = useNavigate();
  let gobackToDashboard = location?.state?.gobackToDashboard || false;

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get("email");

    email && setEmail(email);
  }, [location]);

  const handleGoBack = () => {
    return gobackToDashboard ? navigate("/dashboard") : navigate("/login");
  };

  return (
    <>
      <div style={{ marginBottom: "1.25rem" }}>
        <img alt="Bevz" src={checkImg} width="111px" height="111px" />
      </div>
      <Title style={{ fontSize: "30px", margin: 0 }}>Check your email</Title>
      <Paragraph
        style={{
          color: "#515151",
          fontSize: "16px",
          textAlign: "center",
          marginBottom: "1.875rem",
        }}
      >
        We’ve sent password reset link to your email.
      </Paragraph>

      <Text
        style={{
          fontSize: "1.25rem",
          fontWeight: "500",
          marginBottom: "0.625rem",
        }}
      >
        {email}
      </Text>

      <Paragraph
        style={{
          color: "#515151",
          fontSize: "14px",
          textAlign: "center",
          marginBottom: "3.125rem",
        }}
      >
        If you don’t see the email in your inbox, check your spam folder. If
        it’s not there, it may not match an existing account.
      </Paragraph>

      <Button
        size="large"
        className={style.BlueBrandButton}
        onClick={handleGoBack}
      >
        {gobackToDashboard ? "Back to Dashboard" : "Back to Login"}
      </Button>
    </>
  );
}
